document.addEventListener("DOMContentLoaded", function () {
        // Add to Cart Logic
        document.querySelectorAll(".add-to-cart-btnn").forEach((button) => {
            button.addEventListener("click", function (event) {
                event.preventDefault();
                var variantID = this.getAttribute("data-variant");
                if (!variantID) {
                    alert("Variant ID missing!");
                    return;
                }

                fetch('/cart.js')
                    .then(response => response.json())
                    .then(cart => {
                        var existingItem = cart.items.find(item => item.variant_id == variantID);

                        if (existingItem) {
                            return fetch('/cart/change.js', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({
                                    id: existingItem.key,
                                    quantity: existingItem.quantity + 1
                                })
                            });
                        } else {
                            return fetch('/cart/add.js', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ id: variantID, quantity: 1 })
                            });
                        }
                    })
                    .then(response => response.json())
                    .then(data => {
                        var sideCart = document.querySelector("side-cart.side-cart");
                        if (sideCart) {
                            sideCart.classList.add("is-active");
                            sideCart.setAttribute("drawer-open", "true");
                        }
                        document.documentElement.classList.add("drawer-open");
                        document.body.classList.add("drawer-open");
                        updateSideCart();
                    })
                    .catch(error => {
                        alert("Add to cart failed!");
                        console.error(error);
                    });
            });
        });

        // Quantity change handler
        document.addEventListener("click", function (e) {
            if (e.target.closest("[data-ref='increaseButton']") || e.target.closest("[data-ref='decreaseButton']")) {
                const button = e.target.closest("button");
                const quantityWrapper = button.closest(".cart-row__quantity");
                const variantId = quantityWrapper.getAttribute("data-id");
                const input = quantityWrapper.querySelector("input[data-ref='input']");
                let quantity = parseInt(input.value, 10);

                if (button.getAttribute("data-ref") === "increaseButton") {
                    quantity++;
                } else {
                    quantity = Math.max(1, quantity - 1);
                }

                fetch("/cart/change.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        id: variantId,
                        quantity: quantity
                    }),
                })
                .then((res) => res.json())
                .then(() => updateSideCart())
                .catch((err) => console.error("Quantity update failed:", err));
            }
        });

        // Update side cart HTML
        function updateSideCart() {
            fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                    const cartItemsList = document.querySelector('.cart-items-container') || (() => {
                        const container = document.createElement('div');
                        container.className = 'cart-items-container';
                        const sideCart = document.querySelector("side-cart.side-cart");
                        if (sideCart) {
                            sideCart.appendChild(container);
                        } else {
                            document.body.appendChild(container);
                        }
                        return container;
                    })();

                    cartItemsList.innerHTML = "";
                    cart.items.forEach(item => {
                        const optionsText = item.options_with_values
                            .map(opt => `${opt.name}: ${opt.value}`)
                            .join(', ');

                        cartItemsList.innerHTML += `
                            <div id="shopify-section-cart_item" class="shopify-section SALVO_SECTION SALVO_SECTION-cart_item">
                                <div class="cart-row" data-ref="cartItemRow" data-added="" data-id="${item.variant_id}">
                                    <div class="cart-row__top">
                                        <div class="cart-row__left flex">
                                            <a href="/products/${item.handle}?variant=${item.variant_id}" class="cart-row__image object-cover">
                                                <img src="${item.image || ''}" alt="${item.product_title}" width="300" height="300" data-ref="image">
                                            </a>
                                            <div class="cart-row__cart-info">
                                                <div class="cart-row__info-details">
                                                    <h3 class="cart-row__title body">
                                                        ${item.product_title}
                                                        <br>
                                                        <span class="caption">${optionsText}</span>
                                                    </h3>
                                                    <div class="cart-row__price body" data-ref="itemPrice">
                                                        ${(item.price / 100).toLocaleString('en-US', {style: 'currency', currency: cart.currency})}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="cart-row__information">
                                            <div class="cart-row__info-top">
                                                <div class="cart-row__cart-info--desktop">
                                                    <div class="cart-row__info-details">
                                                        <h3 class="cart-row__title body">
                                                            ${item.product_title}
                                                            <br>
                                                            <span class="caption">${optionsText}</span>
                                                        </h3>
                                                        <div class="cart-row__price body" data-ref="itemPrice">
                                                            ${(item.price / 100).toLocaleString('en-US', {style: 'currency', currency: cart.currency})}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="quantity-container">
                                                    <div class="cart-row__quantity" data-id="${item.variant_id}" data-ref="rowQuantity">
                                                        <quantity-selector class="quantity-selector small" data-ref="quantitySelector" min="1" max="10" value="${item.quantity}">
                                                            <button data-ref="decreaseButton" type="button" aria-label="Decrease Quantity" class="quantity-selector__button" ${item.quantity <= 1 ? 'disabled' : ''}>
                                                                &minus;
                                                            </button>
                                                            <label for="quantitySelector" class="sr-only">Quantity Selector</label>
                                                            <input id="quantitySelector" data-ref="input" type="number" value="${item.quantity}" min="1" max="10" readonly class="quantity-selector__input body">
                                                            <button data-ref="increaseButton" type="button" aria-label="Increase Quantity" class="quantity-selector__button">
                                                                &#43;
                                                            </button>
                                                        </quantity-selector>
                                                    </div>
                                                    <button class="cart-row__remove meta caption" data-ref="removeItem" data-item="${item.variant_id}">
                                                        <span class="visually-hidden">Remove</span>
                                                        <svg class="icon icon--trash
        
    " role="presentation" aria-labelledby="trashTitle" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <title id="trashTitle">A Trash Icon</title>
                <path d="M16.875 3.75H13.75V3.125C13.75 2.62772 13.5525 2.15081 13.2008 1.79917C12.8492 1.44754 12.3723 1.25 11.875 1.25H8.125C7.62772 1.25 7.15081 1.44754 6.79917 1.79917C6.44754 2.15081 6.25 2.62772 6.25 3.125V3.75H3.125C2.95924 3.75 2.80027 3.81585 2.68306 3.93306C2.56585 4.05027 2.5 4.20924 2.5 4.375C2.5 4.54076 2.56585 4.69973 2.68306 4.81694C2.80027 4.93415 2.95924 5 3.125 5H3.75V16.25C3.75 16.5815 3.8817 16.8995 4.11612 17.1339C4.35054 17.3683 4.66848 17.5 5 17.5H15C15.3315 17.5 15.6495 17.3683 15.8839 17.1339C16.1183 16.8995 16.25 16.5815 16.25 16.25V5H16.875C17.0408 5 17.1997 4.93415 17.3169 4.81694C17.4342 4.69973 17.5 4.54076 17.5 4.375C17.5 4.20924 17.4342 4.05027 17.3169 3.93306C17.1997 3.81585 17.0408 3.75 16.875 3.75ZM7.5 3.125C7.5 2.95924 7.56585 2.80027 7.68306 2.68306C7.80027 2.56585 7.95924 2.5 8.125 2.5H11.875C12.0408 2.5 12.1997 2.56585 12.3169 2.68306C12.4342 2.80027 12.5 2.95924 12.5 3.125V3.75H7.5V3.125ZM15 16.25H5V5H15V16.25ZM8.75 8.125V13.125C8.75 13.2908 8.68415 13.4497 8.56694 13.5669C8.44973 13.6842 8.29076 13.75 8.125 13.75C7.95924 13.75 7.80027 13.6842 7.68306 13.5669C7.56585 13.4497 7.5 13.2908 7.5 13.125V8.125C7.5 7.95924 7.56585 7.80027 7.68306 7.68306C7.80027 7.56585 7.95924 7.5 8.125 7.5C8.29076 7.5 8.44973 7.56585 8.56694 7.68306C8.68415 7.80027 8.75 7.95924 8.75 8.125ZM12.5 8.125V13.125C12.5 13.2908 12.4342 13.4497 12.3169 13.5669C12.1997 13.6842 12.0408 13.75 11.875 13.75C11.7092 13.75 11.5503 13.6842 11.4331 13.5669C11.3158 13.4497 11.25 13.2908 11.25 13.125V8.125C11.25 7.95924 11.3158 7.80027 11.4331 7.68306C11.5503 7.56585 11.7092 7.5 11.875 7.5C12.0408 7.5 12.1997 7.56585 12.3169 7.68306C12.4342 7.80027 12.5 7.95924 12.5 8.125Z" fill="#764A25"></path>
            </svg>
                                                    </button>
                                                </div>
                                                <div class="cart-row__total-price body font-weight-regular" data-ref="linePrice">
                                                    ${(item.line_price / 100).toLocaleString('en-US', {style: 'currency', currency: cart.currency})}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="cart-row__bottom">
                                        <div class="cart-row__update"></div>
                                    </div>
                                </div>
                            </div>
                        `;
                    });
                });
        }
    });